import { useState } from 'react';
import './style.css';
const Post = ({url, title, ClickBtn=null,children}) => {
    // const [] = useState();

    return (
        <div className="cardPost_style_1" dir="rtl">
            <div className="cartSectionImage_style_2">
                <img src={url} className='postImage_style_2' />
            </div>
            <div className="postDesctiption_style_2">
                <h6 style={{marginTop: "-0px", zIndex: 999, padding: "5px"}}><b>{title}</b></h6>
                <div className='postContent_style_2'>
                    <hr  style={{marginTop: "-3px", marginRight: "35px", marginLeft: "35px", marginBottom: "10px"}}></hr>
                    <p style={{fontSize: "13px", paddingTop: "0px", height: "35px", MaxHeight: "35px"}}>
                        {children}
                    </p>
                </div>
                <button className="btnPost_style_2"   onClick={ClickBtn!==null ? () => ClickBtn() :''}>مشاهده</button>
            </div>
        </div>
    )
}

export default Post;